// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { IQualifiedTeachersHttpResponse } from 'app_types/admin/qualifiedTeacher/qualifiedTeacherTypes'
import { IUser, IUserHttpResponse } from 'app_types/userTypes'

// @end

class QualifiedTeacherService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  private user: any
  private authObj: any
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
    this.token = this.storeObject.getState().auth?.user?.token
    this.user = this.storeObject.getState().auth.user
    this.authObj = this.storeObject.getState().auth
    this.i18nUtil = new I18nUtil()

  }

  /**
   * Metodo que permite validar si un usuario tiene permiso a un permiso dentro de un modulo
   * @param action Accion que se desea validar
   * @param moduleName Modulo que contiene la accion
   * @returns
   */
  can(action: string, moduleName: string) {
    const user = this.getUserState()

    if (user?.data?.permissions) {
      if (
        user?.data?.permissions[moduleName] !== undefined &&
        user?.data?.permissions[moduleName]?.includes(action)
      ) {
        return true
      }
    }

    return false
  }

  /**
 * Metodo que permite validar si un usuario tiene acceso a un modulo
 * @param moduleName Modulo que se desea validar
 * @returns
 */
  canAccess(moduleName: string) {

    const user = this.getUserState()

    if (user?.data?.permissions) {
      if (user?.data?.permissions[moduleName] !== undefined) {
        return true
      }
    }

    return false
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }


  async list(params: any = {}) {
    this.refreshAuthToken();

    let responseData: IQualifiedTeachersHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/teacher`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    console.log(responseData);
    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData);
    }

    return responseData;
  }

  async listQualifiedTeachers(params: any = {}) {
    this.refreshAuthToken();

    let responseData: IQualifiedTeachersHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/qualifiedTeacher`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData);
    }

    return responseData;
  }

  get = async (params: any = {}) => {
    this.refreshAuthToken();
  }


  insertOrUpdate = async (userData: any, action: string = 'create') => {
    this.refreshAuthToken();
  }

  remove = async (userId: string) => {
    this.refreshAuthToken();
  }

  generateReport = async () => {
    this.refreshAuthToken();

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/teacher/generate-report`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData);
    }

    return responseData;
  }

  /**
   * Obtiene el usuario desde el storage
   * @returns
   */
  private getUserState() {
    const state = this.storeObject.getState()
    const user: IUser = state.auth.user
    return user
  }

}

export default QualifiedTeacherService
